import { ApolloQuery, html } from '@apollo-elements/lit-apollo';
import { css } from 'emotion';
import anime from 'animejs/lib/anime.es.js';
import HomeList from './home-list.graphql';

export class HomeSwiper extends ApolloQuery {

  query = HomeList;
  variables = {};

  constructor() {
    super();
    this.swiper;

    this.prevSlide;
    this.activeSlide;

    this.animation;
    this.animationPrev;
    this.slides;

    this._handlers = {};  
  }

  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    if (!localStorage.getItem(`latitude`) && !localStorage.getItem(`longitude`)) {
      this.variables = null;
    } else {
      this.variables = {
        location: {
          latitude: localStorage.getItem(`latitude`) || null,
          longitude: localStorage.getItem(`longitude`) || null,
        },
      };
    }
    

		super.connectedCallback();
        
		const handlers = this._handlers;

		handlers.onClick = this._onClick.bind(this);
		document.addEventListener(`click`, handlers.onClick);
	}
    
	disconnectedCallback() {
		document.removeEventListener(`click`, this._handlers.onClick);
	}

  _onClick(event) {
    const { target } = event;
    const restAreaElement = target.closest(`.slide-rest-area`);
    const regionElement = target.closest(`.slide-region`);

    if (restAreaElement) {
      window.app.views.main.router.navigate(`/rest-area/${restAreaElement.id}`);
      return;
    }

    if (regionElement) {
      window.app.views.main.router.navigate(`/region/${regionElement.id}`);
      return;
    }
  }

  firstUpdated() {    
    this.slides = this.querySelector(`.swiper-wrapper`);
    this.prevSlide = this.querySelector(`.swiper-slide-prev`);
    this.activeSlide = this.querySelector(`.swiper-slide-active`);    

    this.createSwiper();    
    this.initAnimation();

    this.createRoadview();
  }

  createSwiper() {
    let previousTouchY = 0;
    let scrollY = 0;

    this.swiper = window.app.swiper.create(this.querySelector(`.swiper-container`), {
      direction: 'vertical',
      spaceBetween: 10,
      speed: 300,
      loop: false,
      preventInteractionOnTransition: true,
      on: {
        touchMove: (event) => {
          if (previousTouchY === 0) {
            previousTouchY = event.touches[0].clientY;
            return;
          }

          // 화면 터치 중에 슬라이드 트랜지션 종료
          this.slides.classList.add(`touched`);

          const currentTouchY = event.touches[0].clientY;
          const differentY = (previousTouchY - currentTouchY) / document.body.clientHeight * 100; 

          scrollY += differentY;
          
          if (scrollY > 0) {
            this.slides.classList.add(`scroll-up`);
          } else {
            this.slides.classList.remove(`scroll-up`);
          }

          if (scrollY >= 100) {
            previousTouchY = event.touches[0].clientY;
            return;
          }

          this.animation.seek(scrollY * 10);
          this.animationPrev.seek(1000 + scrollY * 10);        

          previousTouchY = event.touches[0].clientY;
        },
        touchEnd: () => {
          // 터치 끝날시, 트랜지션 시작
          this.slides.classList.remove(`touched`);
          this.slides.classList.remove(`scroll-up`);

          scrollY = 0;
          previousTouchY = 0;
          
          this.animation.seek(0);
          this.animationPrev.seek(0);

          this.slides.classList.add(`delayed`);
          setTimeout(() => this.slides.classList.remove(`delayed`), 300);          
        },
        transitionEnd: () => {          
          this.initAnimation();
        },
      },
    });
  }
  
  initAnimation() {
    this.prevSlide = this.querySelector(`.swiper-slide-prev`);
    this.activeSlide = this.querySelector(`.swiper-slide-active`);
    this.animation = anime({
      targets: '.swiper-container .swiper-slide-active',
      translateY: [
        { value: '0vh', duration: 0 },
        { value: '100vh', duration: 1000 },
      ],
      scale: [
        { value: '1', duration: 0 },
        { value: '0.9', duration: 1000 },
      ],      
      opacity: [
        { value: '1', duration: 0 },
        { value: '0.7', duration: 1000 },
      ],
      easing: 'linear',
      autoplay: false,
    });

    this.animationPrev = anime({
      targets: '.swiper-container .swiper-slide-prev',
      translateY: [
        { value: '0vh', duration: 0 },
        { value: '100vh', duration: 1000 },
        { value: '-100vh', duration: 1000 },
      ],
      scale: [
        { value: '1', duration: 0 },
        { value: '0.9', duration: 1000 },
      ],
      opacity: [
        { value: '1', duration: 0 },
        { value: '0.7', duration: 1000 },
      ],
      easing: 'linear',
      autoplay: false,
    });
  }

  createRoadview() {    
    // 1. createRoadView
    // 2. wait isLoaded() === true
    // 3. next createRoadView (end. this.data.homeList.length)
    let index = 0;
    const create = async (_index) => {
      if (!this.data?.homeList[_index]) {
        return;
      }

      const roadviewContainer = this.querySelector(`.roadview-${_index}-1`);
      const roadView = new kakao.maps.Roadview(roadviewContainer, {
        panoId: this.data?.homeList[_index].restArea.panoId,
        pan: this.data?.homeList[_index].restArea.pan,
        tilt: this.data?.homeList[_index].restArea.tilt,
        zoom: 0,
      });

      while (!roadView.isLoaded()) {
        await this.delay(500);
      }

      const roadviewContainer2 = this.querySelector(`.roadview-${_index}-2`);
      const roadView2 = new kakao.maps.Roadview(roadviewContainer2, {
        panoId: this.data?.homeList[_index].restArea2.panoId,
        pan: this.data?.homeList[_index].restArea2.pan,
        tilt: this.data?.homeList[_index].restArea2.tilt,
        zoom: 0
      });

      while (!roadView2.isLoaded()) {
        await this.delay(500);
      }  
      
      create(++index);
    }

    create(index);
  }
  
  delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  TEMPLATE_SLIDE(param) {
    return html`
    <div class="swiper-slide">
      <section 
        id="${param.regionId}"
        class="slide-region slide-section ${this.STYLE_SLIDE__IMAGE(param.regionImageUrl)}"        
      >
        <sub class="region__top-desc">${param.regionTopSubText}</sub>
        <h2 class="region__title">${param.regionTitle}</h2>
        <sub class="region__bottom-desc">${param.regionBottomSubText}</sub>
      </section>
      ${this.restAreaTemplate(param.index, 1, param.restAreaTopSubText, param.restAreaTitle, param.restAreaId)}
      ${this.restAreaTemplate(param.index, 2, param.restAreaTopSubText2, param.restAreaTitle2, param.restArea2Id)}
    </div>
    `;
  }

  restAreaTemplate(index, subIndex, subText, title, id) {
    return html`
    <section 
      id="${id}"
      class="slide-rest-area slide-section rest-${index}-${subIndex}"
    >
      <sub class="rest-area__top-desc">${subText}</sub>
      <h2 class="rest-area__title">${title}</h2>
      <div class="roadview roadview-${index}-${subIndex}"></div>
    </section>
    `;
  }
  
  render() {
    const { data, error, loading } = this;

    if (this.error) {
      console.log(`reload 10s...`);
      this.error = null;
      setTimeout(() => {
        location.reload();
      }, 10000);
    }

    return (
    loading ? html`
      <div class="preloader"></div>`
    : error ? html`
      <div>Error</div>`
    : html`
      <div class="${this.swiperStyle} swiper-container">
        <div class="swiper-wrapper">
          ${this.data?.homeList.map((list, index) => this.TEMPLATE_SLIDE({
            index,
            regionTopSubText: list.zone?.distance ? (list.zone?.distance / 1000)?.toFixed(2) + `km` : ``,
            regionTitle: list.zone.name,
            regionBottomSubText: ``,
            regionImageUrl: list.zone.image,
            regionId: list.zone.id,
            restAreaTopSubText: list.restArea?.distance ? (list.restArea?.distance / 1000)?.toFixed(2) + `km` : ``,
            restAreaTitle: `${list.restArea.name}${list.restArea.direction ? `(${list.restArea?.direction})` : ``}`,
            restAreaImageUrl: ``,
            restAreaId: list.restArea.id,
            restAreaTopSubText2: list.restArea2?.distance ? (list.restArea2?.distance / 1000)?.toFixed(2) + `km` : ``,
            restAreaTitle2: `${list.restArea2.name}${list.restArea2.direction ? `(${list.restArea2?.direction})` : ``}`,
            restAreaImageUrl2: ``,
            restArea2Id: list.restArea2.id,
          }))}          
        </div>
      </div>
    `);    
  }

  get swiperStyle() {
    return css`
    * {
      user-select: none;
    }

    & {
      display: flex;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    .swiper-container {
      width: 100%;
      height: 100%;      
    }

    .swiper-wrapper {
      position: absolute;
      will-change: transform;
      transition: transform 300ms ease;
    }

    .swiper-slide {
      visibility: hidden;
      text-align: center;
      font-size: 18px;
      background-color: rgb(255, 255, 255);
      box-shadow: 0 0 20px 0 rgba(0,0,0,.35);
    
      display: grid;
      grid-template-rows: 19fr 7fr 7fr;
      grid-template-columns: 1fr;
      justify-content: center;
      align-items: center;
      will-change: transform;
    }

    .scroll-up .swiper-slide-prev {
      visibility: hidden;
    }

    .touched .swiper-slide {
      transition: none;
    }

    .swiper-slide-active,
    .swiper-slide-prev,
    .swiper-slide-next {
      visibility: visible;
      transition: transform 280ms ease;
    }

    .delayed .swiper-slide-prev {
      transform: translateY(100vh) scale(0.93) !important;
    }

    .swiper-slide-prev {
      opacity: 0.7;
      z-index: -1000;
    }

    h2 {
      white-space: pre-line;
    }

    .slide-section {      
      height: 100%;
      justify-content: center;
      display: flex;
      flex-direction: column;
      position: relative;
    }    

    .slide-section > * {
      z-index: 1000;
    }

    .region__title,
    .region__top-desc,
    .region__bottom-desc,
    .rest-area__top-desc,
    .rest-area__title {
      color: #FFFFFF;
      padding-left: 8.8vw;
      text-align: left;
    }    

    .region__top-desc {
      margin-top: 15vh;
      margin-bottom: 1.9vh;
      font-size: 3.1vw;
      color: #FFFFFF;
      text-decoration: underline;
    }

    .region__title {
      font-weight: normal;
      font-size: 5.8vw;
      margin-top: 0;
      margin-bottom: 17px;
    }

    .region__bottom-desc {
      font-size: 3.1vw;
    }

    .rest-area__top-desc {
      font-size: 10px;
      border-top: 1px solid rgba(255, 255, 255, 0.5);
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
      padding: 0;
      margin-left: 8.8vw;
      margin-right: auto;
      z-index: 10000 !important;
    }

    .rest-area__title {
      font-weight: normal;
      font-size: 4.4vw;
      margin-top: 4px;
      margin-bottom: 8vh;
      z-index: 10000 !important;
    }

    .roadview {
      width: 100%;
      height: 100%;
      display: flex;
      position: absolute;
      pointer-events: none;
    }
    `;
  }

  STYLE_SLIDE__IMAGE(imageUrl) {
    return css`
    & {
      overflow: hidden;
      background-color: rgb(0, 0, 0);
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background-image: url(${imageUrl});
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover; 
      opacity: 0.7;
      transform: scale(1.01);
    }
    `;
  }
}

customElements.define('home-swiper', HomeSwiper);